import { useSelectedDealer } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { DealerLicenseQueryKeys } from "modules/DealerLicenseOverview/queryKeys";
import { DEALERS_LICENSES_STORAGE_KEYS } from "modules/DealerLicenseOverview/storageKeys";
import { getPreference, setPreference } from "utils/common";

import type { Dealer } from "models";
import type { DealerLicensesDashboardFilters } from "modules/DealerLicenseOverview/queryKeys";

export const getDefaultDealerLicensesDashboardFilters = (selectedDealer?: Dealer | null): DealerLicensesDashboardFilters => ({
  dealer: getPreference(DEALERS_LICENSES_STORAGE_KEYS.DealerPreference, selectedDealer ?? null)
});

export const useDealerLicensesDashboardFilters = () => {
  const { selectedDealer } = useSelectedDealer();
  return useTypedQuery({ queryKey: DealerLicenseQueryKeys.filters, initialData: getDefaultDealerLicensesDashboardFilters(selectedDealer) }).data;
};

export const setDealerLicensesDashboardFilters = (newFilters: DealerLicensesDashboardFilters) =>
  typedQueryClient.setQueryData(DealerLicenseQueryKeys.filters, { ...newFilters });

export const handleResetFilters = (selectedDealer: Dealer | null) => {
  setPreference(DEALERS_LICENSES_STORAGE_KEYS.DealerPreference, selectedDealer);
  setDealerLicensesDashboardFilters(getDefaultDealerLicensesDashboardFilters(selectedDealer));
};

export const handleDealerChange = (dealer: Dealer | null) => {
  setPreference(DEALERS_LICENSES_STORAGE_KEYS.DealerPreference, dealer);
  setDealerLicensesDashboardFilters({ dealer });
};
